import { render, staticRenderFns } from "./goDialogPromos.vue?vue&type=template&id=ceed1374"
import script from "./goDialogPromos.vue?vue&type=script&lang=js"
export * from "./goDialogPromos.vue?vue&type=script&lang=js"
import style0 from "./goDialogPromos.vue?vue&type=style&index=0&id=ceed1374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports